import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';

@Component({
  selector: 'app-modulos-admin',
  templateUrl: './modulos-admin.component.html',
  styleUrls: ['./modulos-admin.component.css']
})
export class ModulosAdminComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;
  public vecModulo = []; public vecAddModulo = []; public tituloModal: string;
  private accion: number; public banBeca: boolean = true;

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarModulos(1);
  }
  //FUNCION QUE CARGA TODOS LOS MODULOS REGISTRADOS EN EL SISTEMA
  async cargarModulos(op) {
    this.reiniciarTabla();

    this.vecModulo = [];
    this.cargando.abrir();
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(2, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objMod of res.permiso) {
        if (op == 1) {
          if (objMod.intEstado == 1)
            this.agregarModulosVec(objMod.intPadreOpcion, objMod.strNombre, objMod.intEstado == 1 ? 'Activo' : 'Inactivo', objMod.strIcono, objMod.detBeca);
        }
        else
          this.agregarModulosVec(objMod.intPadreOpcion, objMod.strNombre, objMod.intEstado == 1 ? 'Activo' : 'Inactivo', objMod.strIcono, objMod.detBeca);
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //AGREGAR LOS MODULOS DEL SISTEMA A SER MOSTRADOS SEGUN EL ESTADO
  agregarModulosVec(dato1, dato2, dato3, dato4, dato5) {
    this.vecModulo.push({ codigo: dato1, nombre: dato2, estado: dato3, icono: dato4, beca: dato5 });
  }
  //FUNCION QUE ABRE EL MODAL PARA AGREGAR UN NUEVO MODULO
  async modalNuevoModulo(nameMod) {
    this.banBeca = false;
    this.tituloModal = "Agregar una nueva actividad del sistema"; this.accion = 2;
    this.borrarDatos();
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION PARA ABRIL EL MODAL QUE PERMITE EDITAR UN MODULO SELECCIONADO
  modalVerModulo(nameMod, objRol) {
    this.banBeca = true;
    this.tituloModal = "Editar información de la actividad"; this.accion = 3;
    this.buscarModModulo(objRol);
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION QUE PERMITE INGRESAR O EDITAR LOS MODULOS DEL SISTEMA REGISTRADOS
  agregarModulo() {
    if (this.accion == 2) {
      if (this.vecAddModulo[0]['beca'] == 1) {
        this.ingresoActividad(0, this.vecAddModulo[0]['beca']);
      }
      else {
        if (this.accion == 2) {
          if (this.vecAddModulo[0]['beca'] == 2)
            this.agregarTipoBeca(0, 0, 1);
          else
            if (this.vecAddModulo[0]['beca'] == 3)
              this.obtenerBecas('na', 1);
        }
      }
    }
    if (this.accion == 3)
      this.ingresoActividad(0, 0);
  }
  //FUNCION QUE PERMITE INGRESAR O EDITAR LOS MODULOS DEL SISTEMA REGISTRADOS
  ingresoActividad(idBeca, cual) {
    this.srvInsert.ingresoGestionPermisos(this.vecAddModulo[0]['codigo'], this.vecAddModulo[0]['nombre'], this.vecAddModulo[0]['estado'],
      'icono', idBeca, cual, "na", "na", "na", "na", this.accion).subscribe(res => {
        if (res.permiso) {
          if (this.accion == 3)
            this.editarTipoBeca(this.vecAddModulo[0]['tipo'], this.vecAddModulo[0]['nombre'], this.vecAddModulo[0]['estado'],
              this.vecAddModulo[0]['beca'])
          this.alerti.success('La actividad ha sido agregado con éxito');
          this.cerrarModal();
          this.reiniciarTabla();
          this.cargarModulos(1);
        }
        else
          this.alerti.error("No se puede agregar la actividad");
      });
  }
  //FUNCION QUE PERMITE INGRESAR LOS TIPOS DE BECAS (1 INGRESA UNA BECA) (7 INGRESA UN TIPO DE BECA)
  agregarTipoBeca(codigo, beca, opcion) {
    this.srvInsert.ingresoGestionBecas(codigo, this.vecAddModulo[0]['nombre'], "na", this.vecAddModulo[0]['estado'],
      beca, "na", "na", "na", "na", "na", 'na', 'na', 'na', 'na', opcion).subscribe(res => {
        if (res.becas) {
          if (opcion == 1)
            this.obtenerBecas(this.vecAddModulo[0]['nombre'], 9);
          if (opcion == 7)
            this.obtenerBecas(this.vecAddModulo[0]['nombre'], 7);
        }
        else
          this.alerti.error("No se puede agregar la actividad");
      });
  }
  //EDITAR LOS TIPOS DE BECA (11 EDITA UNA BECA) (10 EDITA UN TIPO DE BECA)
  editarTipoBeca(codigo, nombre, estado, opcion) {
    if (opcion == 2 || opcion == 3) {
      this.srvInsert.ingresoGestionBecas(codigo, nombre, "na", estado, "na", "na", "na", "na", "na", "na", 'na', 'na', 'na', 'na', opcion == 2 ? 11 : 10).subscribe(res => {
        if (!res.becas)
          this.alerti.error("No se puede agregar la actividad");
      });
    }
  }
  //FUNCION QUE OBTIENE UNA BECA O TIPO DE BECA (7TIPO DE BECA) O (9 BECA)
  async obtenerBecas(criterio, opcion) {
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(opcion, criterio, "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      if (opcion == 9 || opcion == 7)
        this.ingresoActividad(res.becas[0]['idBeca'], this.vecAddModulo[0]['beca']);
      if (opcion == 1)
        this.agregarTipoBeca(0, res.becas[0]['intIdBecas'], 7)
    }
    else
      this.alerti.error("No hay registro de becas");
  }
  //FUNCION QUE BUSCA UN ROL REGISTRADO EN EL SISTEMA DADO EL CODIGO
  async buscarModModulo(buscar) {
    this.cargando.abrir();
    this.vecAddModulo = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(3, buscar, "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecAddModulo.push({
        codigo: res.permiso[0]['intPadreOpcion'], nombre: res.permiso[0]['strNombre'], beca: res.permiso[0]['beca'],
        estado: res.permiso[0]['intEstado'], icono: res.permiso[0]['strIcono'], tipo: res.permiso[0]['tipo']
      });
    }
    else
      this.borrarDatos();
    this.cargando.cerrar();
  }
  //FUNCION PARA INSTANCIAR LAS VARIABLES
  borrarDatos() {
    this.vecAddModulo = [];
    this.vecAddModulo.push({
      codigo: "", nombre: "", estado: 1, icono: "", beca: 1, tipo: 0
    });
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    var table3 = $('#tblModulo').DataTable({ destroy: true });
    table3.destroy();
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
